<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">What school are you going to?</h2>
        </div>

        <div class="step-body">
            <SchoolSearchAutoComplete
                @updateSchoolAndCampus="onSchoolSelect"
                :initial-value="selectedSchoolName"
            />

            <div v-if="selectedSchool" class="selected-school">
                <v-chip
                    close
                    color="primary"
                    text-color="white"
                    @click:close="clearSchool"
                >
                    {{ selectedSchool.name }}
                </v-chip>
            </div>
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="!selectedSchool"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>
        </div>
    </div>
</template>

<script>
import SchoolSearchAutoComplete from '@/components/SchoolAutoComplete.vue';

export default {
    name: 'SchoolStep',

    components: {
        SchoolSearchAutoComplete
    },

    props: {
        schoolSlug: {
            type: String,
            default: null
        }
    },

    computed: {
        selectedSchool() {
            return this.$store.getters['Questionnaire/getAnswer']('school');
        },
        selectedSchoolName() {
            return this.selectedSchool?.name || '';
        }
    },

    methods: {
        onSchoolSelect(campus) {
            this.$store.dispatch('Questionnaire/setAnswer', {
                key: 'school',
                value: {
                    id: campus.school_id,
                    campus_id: campus.id,
                    name: campus.school?.name || campus.name
                }
            });
        },

        clearSchool() {
            this.$store.dispatch('Questionnaire/setAnswer', {
                key: 'school',
                value: null
            });
        },

        onNext() {
            if (this.selectedSchool) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.step-body {
    flex: 1;
}

.selected-school {
    margin-top: 16px;
    display: flex;
    justify-content: center;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}
</style>
